import React from 'react';
import './index.scss';

const TextBlock = (props) => {
  return (
    <div className={`text-block`}>
      <div className="wrapper">
        <div className={`text-left content ${props.textPadded ? 'padded' : ''}`}>
          {props.textLeft}
        </div>
        <div className={`text-right content ${props.textPadded ? 'padded' : ''}`}>
          {props.textRight}
        </div>
      </div>
    </div>
  );
}

export default TextBlock;

TextBlock.defaultProps = {
  textPadded: false,
  textLeft: '',
  textRight: '',
}
